import React from 'react';
import './Homeboxes.css';
import { Card, CardTitle, Row, Col, Container } from 'reactstrap';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { faCalendarPlus, faCoins, faCodeBranch, faMoneyCheckAlt, faStreetView, faHospital, faMap } from '@fortawesome/fontawesome-free-solid';
import Config from '../../../Core/Config.js';
import {framework} from 'saffroncodejs';
var PageManager = framework.PageManager ;
const Homeboxes = (props) => {

    return (
        <div className="homeB">
            <Container>
                <Row>
                    <Col sm="4" md="3">
                        <Card body onClick={() => {PageManager.changePage(Config.p_news) }}>
                            <CardTitle className='parallelogram'>
                                <FontAwesomeIcon icon={faCalendarPlus} className="fontinhomebox" />
                            </CardTitle>
                            <CardTitle>طرح ها و جشنواره ها</CardTitle>
                        </Card>
                    </Col>
                    <Col sm="4" md="3">
                        <Card body onClick={() => {PageManager.changePage(Config.p_pardakhtman) }} >
                            <CardTitle className='parallelogram'>
                                <FontAwesomeIcon icon={faCoins} className="fontinhomebox" />
                            </CardTitle>
                            <CardTitle>پرداخت های من</CardTitle>
                        </Card>
                    </Col>
                    <Col sm="4" md="3">
                        <Card body onClick={() => {PageManager.changePage(Config.p_branches) }} >
                            <CardTitle className='parallelogram'>
                                <FontAwesomeIcon icon={faCodeBranch} className="fontinhomebox" />
                            </CardTitle>
                            <CardTitle>اطلاعات شعب (صدور و خسارت)</CardTitle>
                        </Card>
                    </Col>
                    <Col sm="4" md="3">
                        <Card body onClick={() => {PageManager.changePage(Config.p_estelam) }}>
                            <CardTitle className='parallelogram'>
                                <FontAwesomeIcon icon={faMoneyCheckAlt} className="fontinhomebox" />
                            </CardTitle>
                            <CardTitle>استعلام قیمت بیمه نامه</CardTitle>
                        </Card>
                    </Col>
                    <Col sm="4" md="4">
                        <Card body onClick={() => {PageManager.changePage(Config.p_nearestbranches) }}>
                            <CardTitle className='parallelogram'>
                                <FontAwesomeIcon icon={faMap} className="fontinhomebox" />
                            </CardTitle>
                            <CardTitle>نزدیکترین شعبه به من </CardTitle>
                        </Card>
                    </Col>
                    <Col sm="4" md="4">
                        <Card body  onClick={()=>window.open('http://www.novininsurance.com/index.aspx?siteid=1&fkeyid=&siteid=1&pageid=174')}>
                            <CardTitle className='parallelogram' >
                                <FontAwesomeIcon icon={faHospital} className="fontinhomebox" />
                            </CardTitle>
                            <CardTitle>مراجع درمانی</CardTitle>
                        </Card>
                    </Col>
                    <Col sm="4" md="4">
                        <Card body onClick={() => {PageManager.changePage(Config.p_nearestagency) }}>
                            <CardTitle className='parallelogram'>
                                <FontAwesomeIcon icon={faStreetView} className="fontinhomebox" />
                            </CardTitle>
                            <CardTitle>نزدیکترین نمایندگی به من</CardTitle>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </div>
    );

};

export { Homeboxes };



// WEBPACK FOOTER //
// ./src/components/Home/Homeboxes/Homeboxes.js